// extracted by mini-css-extract-plugin
export default {"small_section":"smallsection_small_section__g7FD3"};